import { render } from "./FollowupPaymentSuccess.vue?vue&type=template&id=3452fd24&scoped=true"
import script from "./FollowupPaymentSuccess.vue?vue&type=script&lang=js"
export * from "./FollowupPaymentSuccess.vue?vue&type=script&lang=js"

import "./FollowupPaymentSuccess.vue?vue&type=style&index=0&id=3452fd24&scoped=true&lang=css"

import exportComponent from "C:\\Users\\PamelaOsunza\\OneDrive - dermapp.com\\Escritorio\\dermapp\\dermapp-pacientes-staging\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3452fd24"]])

export default __exports__